export const plans = [
  {
    tier: "Basic",
    duration: "Monthly",
    price: 9.99,
    summary: "SD 720P + 1 device",
    recommended: false,
    features: [
      "Very Good",
      "Amazing",
      "Perfect Job",
      "Love this",
      "It's so good",
      "Features",
    ],
    color: "#ffcc00",
  },
  {
    tier: "Advanced",
    duration: "Monthly",
    price: 12.99,
    summary: "HD 1080P + 3 devices",
    recommended: true,
    features: [
      "Very very Good",
      "Even Amazing",
      "Perfect Job",
      "Love this more",
      "It's so so good",
      "More Features",
    ],
    color: "#097054",
  },
  {
    tier: "Pro",
    duration: "Monthly",
    price: 15.99,
    summary: "4K UHD + 5 devices",
    recommended: false,
    features: [
      "Very very Good",
      "Even Amazing",
      "Perfect Job",
      "Love this more",
      "It's so so good",
      "More Features",
    ],
    color: "#cc0000",
  },
];
